<template>
    <main slot="content" id="content" class="content" role="main">
      <Header/>
      <Menu/>
      <router-view></router-view>
      <Footer/>
    </main>
</template>

<script>
import Header from './Header.vue';
import Menu from './Menu.vue';
import Footer from './Footer.vue';
import utils from '../services/utils';
/* eslint-disable */

export default {
  name: 'web-layout',

  components: {
    Header,
    Menu,
    Footer,
  },
  created() {

  },
  data () {
    return {
      source: utils.getUserPersistent().user.source,
    }
  },
  methods: {

  },
  computed: {
    // ...mapGetters([
    //   'isLoading'
    // ])
  }
}
</script>

<style scoped>
body {
  min-height:100%;
}
.fix-footer {
  /* position: absolute;
  bottom: 0;
  text-align: center; */
  /* position:fixed;  */
  /* bottom:0;  */
  /* width:100%; */
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  /* padding: 1rem; */
  /* background-color: #efefef; */
  text-align: center;
}
</style>

